import styled from "styled-components";

export const LabelWithInfoIconWrapper = styled.div`
  margin-top: 8px;
  .label-container {
    display: flex;
  }
`;
